import React from 'react';
import { motion } from 'framer-motion';
interface CardProps {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
  hoverEffect?: boolean;
}
export function Card({
  children,
  className = '',
  onClick,
  hoverEffect = false
}: CardProps) {
  return <motion.div className={`
        bg-white rounded-3xl border border-slate-200 shadow-sm overflow-hidden
        ${onClick ? 'cursor-pointer' : ''}
        ${className}
      `} onClick={onClick} whileHover={hoverEffect && onClick ? {
    y: -4,
    boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
    borderColor: 'rgb(199 210 254)' // indigo-200
  } : {}} transition={{
    type: 'spring',
    stiffness: 400,
    damping: 25,
    duration: 0.2
  }} data-id="element-5403">

      {children}
    </motion.div>;
}